import { Grid, IconButton } from "@mui/material";
import React, { useEffect } from "react";
import { ClearRounded } from "@mui/icons-material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const ViewBranch = (props) => {
  const { t } = useTranslation();
  const { setShowForm, viewData } = props;
  const [branch, setBranch] = useState({});
  const handleClose = () => {
    setShowForm(false);
  };

  useEffect(() => {
    if (viewData) {
      setBranch({
        ...viewData,
        city: viewData.city && viewData.city.name,
      });
    }
  }, [viewData]);

  return (
    <>
      {branch ? (
        <Grid container spacing={3} className="p-15 dark-color mb-10">
          <Grid item xs={12}>
            <div className="mb-15 d-flex j-between a-center">
              <div>
                <span
                  className="fs-20 mb-5 fw-5 gray-color tx-upp
                    border-left"
                >
                  {t("BranchDetails")}
                </span>
              </div>

              <div>
                <IconButton onClick={handleClose} size="small" className="mr-5">
                  <ClearRounded className="fs-20 m-2" />
                </IconButton>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color grayMD-color">
              {t("BranchId")}
            </span>
            <span className="fs-16 fw-4 gray-color">{branch.id}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("BranchName")}:
            </span>
            <span className="fs-16 fw-4 gray-color gray-color">
              {branch.name}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("Country")}
            </span>
            <span className="fs-16 fw-4 gray-color">{branch.countryName}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("Currency")}
            </span>
            <span className="fs-16 fw-4 gray-color">{branch.currency}</span>
          </Grid>

          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("Mobile")}
            </span>
            <a
              className="link fs-16 fw-4 gray-color"
              href={`tel:${branch.phone}`}
            >
              {branch.phone}
            </a>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">{t("Email")}</span>
            <a
              className="link fs-16 fw-4 gray-color"
              href={`mailto:${branch.email}`}
            >
              {branch.email}
            </a>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("FeezeFees")}
            </span>
            <span className="fs-16 fw-4 gray-color">
              {branch.transferFees} {branch.currency}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("EnrollmentFees")}
            </span>
            <span className="fs-16 fw-4 gray-color">
              {branch.enrollmentFees} {branch.currency}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("TransferFees")}
            </span>
            <span className="fs-16 fw-4 gray-color">
              {branch.transferFees} {branch.currency}
            </span>
          </Grid>

          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">Website</span>
            <a
              className="link fs-16 fw-4 gray-color"
              href={branch.website}
              target="_blank"
              rel="noreferrer"
            >
              {branch.website}
            </a>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("MachineIP")}:
            </span>
            <span className="fs-16 fw-4 gray-color">{branch.machineIP}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("ServerIP")}
            </span>
            <span className="fs-16 fw-4 gray-color">{branch.serverIP}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("TaxNo")}.
            </span>
            <span className="fs-16 fw-4 gray-color">{branch.taxNo}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("AutoEmailSend")}
            </span>
            <span className="fs-16 fw-4 gray-color">
              {branch.autoEmail ? "Yes" : "No"}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("BiometricIntegration")}
            </span>
            <span className="fs-16 fw-4 gray-color">
              {branch.biometric ? "Yes" : "No"}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("AddedDate")}
            </span>
            <span className="fs-16 fw-4 gray-color">{branch.createDate}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("LastUpdateDate")}
            </span>
            <span className="fs-16 fw-4 gray-color">{branch.updateDate}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">{t("City")}</span>
            <span className="fs-16 fw-4 gray-color">{branch.city}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">{t("State")}</span>
            <span className="fs-16 fw-4 gray-color">{branch.state}</span>
          </Grid>
          <Grid item xs={12} md={8} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("Address")}:
            </span>
            <span className="fs-16 fw-4 gray-color">{branch.address}</span>
          </Grid>
        </Grid>
      ) : (
        `${"Loading"}...`
      )}
    </>
  );
};

export default ViewBranch;
